import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { fondDuLacConfig } from "./data";

export default function FondDuLacPage() {
  return <CityPageTemplate config={fondDuLacConfig} />;
}